import React from 'react';
import { Pane, Text, Flex } from '@leverege/ui-elements';
import S from './MapKey.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class MapKeyItem extends React.Component {
  render() {
    const {
      imgSrc,
      imgClass,
      imgBg,
      title,
      children
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      className: S.mapKeyDiv,
      children: [/*#__PURE__*/_jsx("div", {
        className: imgBg,
        children: /*#__PURE__*/_jsx("img", {
          alt: title,
          src: imgSrc,
          className: imgClass === undefined ? S.iconStandard : imgClass
        })
      }), /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colM",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "captionBold",
          children: title
        }), /*#__PURE__*/_jsx(Text, {
          variant: "captionSmall",
          className: S.stateDescription,
          children: children
        })]
      })]
    });
  }
}